import React from "react";
import { EnrolledCoursesProgressBar1 } from "./learn1";
import { CompletedCourses } from "./CompletedCourse";
import { useNavigate } from "react-router";
import { MdAddCircleOutline } from "react-icons/md";
export default function () {
  const navigate = useNavigate();


  return (
    <div className="border-t pt-4 px-8 md:px-4 lg:px-4 lg:w-[100%]">
      <div className="flex justify-between items-center md:px-8 lg:px-8 lg:py-4">
        <p className="text-[20px] text-black lg:text-xl lg:font-semibold ">Enrolled Courses</p>
        <button
          className="hidden md:block lg:block flex flex-row-reverse rounded-xl border-2 border-primary md:px-8 lg:px-8 py-2 bg-white text-primary hover:bg-primary hover:text-white "
          onClick={() => navigate("/dashboard/learn")}
        >
          <span className="flex items-center lg:text-xl ">
            <MdAddCircleOutline></MdAddCircleOutline>
            <p className="px-2 ">Enroll new course</p>
          </span>
        </button>
      </div>
      <div >
      <EnrolledCoursesProgressBar1
      onCLickEmptyEnroll={() => navigate("/dashboard/learn")}
      ></EnrolledCoursesProgressBar1>
      </div>

      <CompletedCourses></CompletedCourses>
      {/* <EnrolledCoursesComponent></EnrolledCoursesComponent> */}
      {/* <Learn></Learn> */}
    </div>
  );
}
